import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useClientAuth } from "../contexts/ClientAuthContext";
import { useStaffAuth } from "../contexts/StaffAuthContext";

function Loader() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f9fafc">
      <CircularProgress sx={{ color: "#6db43d" }} />
    </Box>
  );
}

export function ClientProtected({ children }) {
  const { isAuthenticated, loading } = useClientAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export function StaffProtected({ children, requireAdmin = false }) {
  const { isAuthenticated, isAdmin, loading } = useStaffAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!isAuthenticated) return <Navigate to="/staff/login" state={{ from: location }} replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/staff" replace />;
  return children;
}
